module.exports = __webpack_public_path__ + "images/emoji/rabbit.4f75dbb8415d79d38197.png";